import styled from 'styled-components/macro';

const InputCriterium = styled('div')`
  width: 250px;
  padding-right: 20px;
`;

export default InputCriterium;
